import { request } from "@/utils/remoteRequest";

export function getData(data) {
  return request({
    url: "/main/searchPostInfoByDeptForMain",
    method: "post",
    data,
  });
}
